<template>
  <div>
    <b-card header="Interesses">
      <nav>
        <b-pagination
          :total-rows="getRowCount(items)"
          :per-page="perPage"
          v-model="currentPage"
          prev-text="Anterior"
          next-text="Próxima"
          hide-goto-end-buttons
        />
      </nav>
      <b-card class="text-center f-g" v-if="items.length <= 0">
        <i class="fa fa-frown-o fa-custom-size"></i>
        <h4>Desculpe, não encontramos nenhum interesse :(</h4>
      </b-card>
      <b-table
        :items="items"
        :fields="fields"
        v-if="items.length > 0"
        bordered
        striped
        hover
        responsive="sm"
        :current-page="currentPage"
        :per-page="perPage"
        @row-clicked="editarImagem"
      >
        <template v-slot:cell(descricao)="data">
          <h5 class="texto-descricao">{{data.item.descricao}}</h5>
        </template>
        <template v-slot:cell(imagemdirecionada)="data">
          <img
            v-if="data.item.imagemdirecionada"
            :src="data.item.imagemdirecionada"
            alt="Imagem referente a descrição"
            class="imagem-interesse"
          />
          <span v-else class="texto-imagem-interesse">
            <small>Sem imagem.</small>
          </span>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";

import axios from "axios";
import * as config from "@/config.json";

export default {
  name: "interesses",
  components: {
    Loading
  },
  data: function() {
    return {
      items: [],
      fields: [
        { key: "descricao", label: "Descrição" },
        { key: "imagemdirecionada", label: "Imagem" }
      ],
      currentPage: 1,
      perPage: 5,
      totalRows: 0
    };
  },
  methods: {
    getRowCount(items) {
      return items.length;
    },
    editarImagem(record, index) {
      localStorage.setItem("desc_interesse", record.descricao);
      localStorage.setItem("img_interesse", record.imagemdirecionada);
      this.$router.push({
        path: `/interesses/editar/${record.interesseid}`
      });
    }
  },
  beforeMount() {
    axios
      .get(
        `${
          config.default.servidor
        }/gerencial/retorna-interesses-por-empresa/${localStorage
          .getItem("enterprise_id")
          .toString()}`,
        {
          headers: {
            Authorization: "Basic c2E6QURNQUNDRVNZUw=="
          }
        }
      )
      .then(response => {
        if (response.status == 200) {
          this.items = response.data.data;
        }
      });
  }
};
</script>

